import styled from 'styled-components';
import { BodyBoldS } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const ContentCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    padding:
      ${theme.layout.spacing.decy}
      ${theme.layout.spacing.decy}
      ${theme.layout.spacing.tera};
  `}
`;

export const ContentText = styled(BodyBoldS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;
